import { Component, OnInit, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-hero-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hero-section.component.html',
  styleUrl: './hero-section.component.css'
})
export class HeroSectionComponent implements OnInit {
  stats = [
    { value: '4.8', label: 'Rating' },
    { value: '50K+', label: 'Total Download' },
    { value: '10k', label: 'Customer' }
  ];

  animatedValues: string[] = ['0.0', '0K+', '0k'];

  constructor(private zone: NgZone) {}

  ngOnInit(): void {
    this.animateStats();
  }

  private animateStats(): void {
    const duration = 2000;
    const steps = 60;
    const stepDuration = duration / steps;
    let step = 0;

    const timer = setInterval(() => {
      step++;
      const t = Math.min(step / steps, 1);
      const eased = 1 - Math.pow(1 - t, 3);

      this.zone.run(() => {
        this.animatedValues = [
          (4.8 * eased).toFixed(1),
          Math.floor(50 * eased) + 'K+',
          Math.floor(10 * eased) + 'k',
        ];

        if (step >= steps) {
          clearInterval(timer);
          this.animatedValues = ['4.8', '50K+', '10k'];
        }
      });
    }, stepDuration);
  }
}
